import styles from './LocalePicker.module.scss';

import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { Image } from 'components/Image/Image';
import { ModalHeader } from 'components/Modal/Header/ModalHeader';
import { Modal } from 'components/Modal/Modal';
import * as Locales from 'utils/Locales';
import { Region } from './Region';
import { LOCALE_PICKER_TEST_ID } from './LocalePicker.const';

interface ILocalePickerState {
  localePickerIsOpen: boolean;
}

class LocalePicker extends React.PureComponent<WithTranslation, ILocalePickerState> {
  state = { localePickerIsOpen: false };
  headingId = 'locale-picker-modal-heading';

  render() {
    const { i18n } = this.props;
    const currentLocale = Locales.getLocale(i18n.language);

    if (currentLocale.code !== i18n.language)
      console.error(`Unable to determine the locale information for locale code ${i18n.language}`);

    return (
      <>
        <button
          className={styles.localePickerButton}
          data-testid={LOCALE_PICKER_TEST_ID.button}
          onClick={() => this.toggleLocalePicker(true)}
        >
          <Image aria-hidden src={currentLocale.country.icon} offset={100} />
          <span>{currentLocale.displayName}</span>
        </button>
        {this.state.localePickerIsOpen && (
          <Modal
            className={styles.modal}
            isOpen
            onRequestClose={() => this.toggleLocalePicker(false)}
            aria={{ modal: true, labelledby: this.headingId }}
          >
            <ModalHeader
              heading="Choose your country"
              headingId={this.headingId}
              onCloseButtonClick={() => this.toggleLocalePicker(false)}
            />
            <div className={styles.body}>
              {Object.values(Locales.supportedDataCenters).map(dc => (
                <Region key={dc.code} dataCenter={dc} closeModal={this.closeModal} />
              ))}
            </div>
          </Modal>
        )}
      </>
    );
  }

  private toggleLocalePicker = (forceState?: boolean) => {
    if (forceState !== undefined) {
      this.setState({ localePickerIsOpen: forceState });
      return;
    }

    this.setState({ localePickerIsOpen: !this.state.localePickerIsOpen });
  };

  private closeModal = () => this.toggleLocalePicker(false);
}

const Translated = withTranslation()(LocalePicker);

export { LocalePicker as _LocalePicker, Translated as LocalePicker, ILocalePickerState as LocalePickerState };
